module.exports = __webpack_public_path__ + "img/listMode.36fb1155.svg";